export default "__VITE_ASSET__eeb32848__"